import { articles } from "@/mocks/articleData";
import { Link } from "react-router-dom";

export default function LatestArticles() {
  return (
    <section className="bg-background-100/50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-14">
          <div>
            <span className="inline-block px-4 py-1.5 bg-background-50 rounded-full text-xs font-semibold text-foreground-700 mb-4 tracking-wider">
              RESOURCES
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
              Latest Guides & Articles
            </h2>
            <p className="text-foreground-600 text-sm max-w-lg">
              In-depth SEO articles covering CSSBuy, Kakobuy, Superbuy, Oopbuy spreadsheet systems and smart shopping strategies.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              className="group bg-background-50 rounded-2xl border border-background-200/60 p-6 hover:border-primary-300/60 hover:shadow-sm transition-all cursor-pointer"
            >
              <div className="flex items-center gap-2 mb-4">
                <span className="px-3 py-1 bg-accent-100/60 rounded-full text-xs font-semibold text-accent-800">
                  {article.category}
                </span>
                <span className="text-xs text-foreground-500">{article.readTime}</span>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-3 leading-snug group-hover:text-primary-600 transition-colors">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-3">
                {article.summary}
              </p>
              <div className="flex items-center gap-2 text-sm text-primary-600 font-medium">
                Read Article
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 transition-transform"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}